import React from 'react'
import { Link } from 'react-router-dom'
import { Tag } from 'antd'

import { compactBahtFromValue } from '../dashboard/format'
import { orderKindLabel, ORDER_STATE_COLORS } from '../../Companies/detail/format'

// Shared order-table format for the Customer and Company detail overviews so the
// two pages stay identical. The Company page additionally passes a `contactColumn`
// (its orders span many contacts); the Customer page omits it.

// Pagination config shared by both order tables.
export const ORDER_TABLE_PAGINATION = { pageSize: 10, size: 'small', hideOnSinglePage: true, showSizeChanger: false }

const staffNames = (list) => (list || []).map((s) => s.firstName || s.fullName).filter(Boolean).join(', ')

// Order รายละเอียด: delivery place + the CS/Sale/SCM/Logistic routing line.
export const orderDetail = (o) => {
    const addr = o.orderShippingAddress
    const place = o.selfPickup
        ? 'ลูกค้ารับสินค้าเอง'
        : (addr ? [addr.district && addr.district.name, addr.province && addr.province.name, addr.postalCode].filter(Boolean).join(' ') : '')
    const routing = `CS: ${staffNames(o.cses)} // Sale: ${staffNames(o.sales)} // SCM: ${o.scmFirstName || ''} // Logistic: ${staffNames(o.logistics)}`
    return { place, routing }
}

export const buildOrderColumns = ({ contactColumn } = {}) => {
    const numberCol = {
        title: 'เลขที่',
        key: 'number',
        width: 160,
        render: (o) => {
            const projectName = o.companyProject && o.companyProject.name
            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Link className="num" to={`/inquiries/${o.number}`}>{o.number}</Link>
                    <span className="cell-secondary">
                        {orderKindLabel(o.state)}{projectName ? ` · ${projectName}` : ''}
                    </span>
                </div>
            )
        }
    }
    const detailCol = {
        title: 'รายละเอียด',
        key: 'detail',
        render: (o) => {
            const { place, routing } = orderDetail(o)
            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {place ? <span>{place}</span> : null}
                    <span className="cell-secondary">{routing}</span>
                </div>
            )
        }
    }
    const valueCol = {
        title: 'มูลค่า',
        key: 'value',
        width: 110,
        align: 'right',
        render: (o) => <span className="num">{compactBahtFromValue(o.grandTotal && o.grandTotal.value)}</span>
    }
    const stateCol = {
        title: 'สถานะ',
        key: 'state',
        width: 130,
        render: (o) => <Tag color={ORDER_STATE_COLORS[o.state] || 'default'}>{o.stateLabel || o.state}</Tag>
    }
    const dateCol = {
        title: 'วันที่',
        key: 'date',
        width: 110,
        render: (o) => (o.createdAt && o.createdAt.shortDate) || '-'
    }

    const cols = [numberCol, detailCol]
    if (contactColumn) cols.push(contactColumn)
    cols.push(valueCol, stateCol, dateCol)
    return cols
}
